import fetcher from 'api/fetcher';
import { RefundReason } from 'utils/constants/admin';
import { NotificationName } from 'utils/constants/notification';

import refundFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/refund_form_submit';

import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const sendRefund = (
    invoiceId: number,
    amount: string,
    setLoadRefund: (value: boolean) => void,
    fetchRefund: (id: number) => void,
    refundReason: RefundReason
): AppThunkAction<void> => {
    return (dispatch, getState) => {
        setLoadRefund(true);

        const user = getState().user.user;
        const userId = user?.id;
        const accountId = user?.currentAccount.id;

        void fetcher
            .post(`/api/v1/backoffice/invoices/refund?invoice_id=${invoiceId}&amount=${amount}&reason=${refundReason}`)
            .then(() => {
                fetchRefund(invoiceId);
            })
            .then(() => {
                dispatch(addNotification(NotificationName.SendRefund));
                refundFormSubmit({
                    amount,
                    userId: userId ?? 0,
                    accountId: accountId ?? 0,
                    paymentSource: 'backoffice',
                    invoiceId,
                    refundReason,
                });
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.SomethingWentWrong));
            })
            .finally(() => {
                setLoadRefund(false);
            });
    };
};
